(() => {
  const CONTAINER_SEL = '[id^="shopify-section"], .quick-add-modal, .quick-add, .modal';

  // --- CLICK: show spinner, add .loading, set opacity, and set Quantity.1 ---
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('a[id^="amazon-buy-btn--"]');
    if (!btn) return;

    const container = btn.closest(CONTAINER_SEL) || document;

    // Quantity input inside that container (fallback clamps to 1+)
    const qtyInput = container.querySelector('input.quantity__input[name="quantity"]');
    const rawVal = parseInt(qtyInput?.value, 10);
    const minAttr = qtyInput?.getAttribute('min') ?? qtyInput?.dataset?.min ?? '1';
    const maxAttr = qtyInput?.getAttribute('max'); // might be "null"
    const min = Math.max(1, parseInt(minAttr, 10) || 1);
    const max = maxAttr && maxAttr !== 'null' ? parseInt(maxAttr, 10) : Infinity;
    const qty = Number.isFinite(rawVal) ? Math.min(max, Math.max(min, rawVal)) : min;

    // Update Quantity.1 in URL
    try {
      const url = new URL(btn.href);
      url.searchParams.set('Quantity.1', String(qty));
      btn.href = url.toString();
    } catch {
      if (/Quantity\.1=\d+/.test(btn.href)) {
        btn.href = btn.href.replace(/(Quantity\.1=)\d+/, `$1${qty}`);
      } else {
        btn.href += (btn.href.includes('?') ? '&' : '?') + `Quantity.1=${qty}`;
      }
    }

    // Loading UI
    const spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
    btn.classList.add('loading');
    btn.style.opacity = '0.5';

    // Auto-reset after 5s (in case navigation doesn't occur)
    setTimeout(() => {
      if (spinner) spinner.classList.add('hidden');
      btn.classList.remove('loading');
      btn.style.opacity = '';
    }, 5000);
  });

  // --- VARIANT CHANGE: update ASIN.1 for any amazon button within the same container ---
  function updateAmazonAsin(container) {
    if (!container) return;

    // Current variant ID from Dawn's product form
    const currentVariantId = container.querySelector('input[name="id"]')?.value;
    if (!currentVariantId) return;

    // Find ASIN map in this container (your <script id="asin-map-..."> JSON)
    const mapScript = container.querySelector('script[id^="asin-map-"]');
    if (!mapScript) return;

    let asinMap = {};
    try {
      asinMap = JSON.parse(mapScript.textContent || '{}');
    } catch {
      /* noop */
    }
    const asin = asinMap[currentVariantId];
    if (!asin) return;

    // Update all Amazon buttons inside this container
    container.querySelectorAll('a[id^="amazon-buy-btn--"]').forEach((btn) => {
      try {
        const url = new URL(btn.href);
        url.searchParams.set('ASIN.1', asin);
        btn.href = url.toString();
      } catch {
        if (/ASIN\.1=[^&]+/.test(btn.href)) {
          btn.href = btn.href.replace(/(ASIN\.1=)[^&]+/, `$1${encodeURIComponent(asin)}`);
        } else {
          btn.href += (btn.href.includes('?') ? '&' : '?') + `ASIN.1=${encodeURIComponent(asin)}`;
        }
      }
    });
  }

  // On variant control change (PDP + quick-add modal)
  document.addEventListener('change', (e) => {
    const container = e.target.closest(CONTAINER_SEL);
    if (!container) return;
    updateAmazonAsin(container);
  });

  // --- PRIME visible containers on initial load ---
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(CONTAINER_SEL).forEach(updateAmazonAsin);
  });

  // --- HANDLE DYNAMICALLY INJECTED MODALS / SECTIONS ---
  // 1) Observe DOM additions (e.g., quick-add modal injected)
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        // If the node itself is (or contains) a target container, prime it
        if (node.matches?.(CONTAINER_SEL)) {
          updateAmazonAsin(node);
        }
        node.querySelectorAll?.(CONTAINER_SEL).forEach(updateAmazonAsin);

        // Some themes inject just the variant form; catch that too
        const vs = node.matches?.('variant-selects') ? [node] : node.querySelectorAll?.('variant-selects') || [];
        vs.forEach((v) => updateAmazonAsin(v.closest(CONTAINER_SEL)));
      });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // 2) Shopify section lifecycle events (when a section is re-rendered)
  document.addEventListener('shopify:section:load', (e) => updateAmazonAsin(e.target));
  document.addEventListener('shopify:section:select', (e) => updateAmazonAsin(e.target));
  document.addEventListener('shopify:section:unload', (e) => updateAmazonAsin(e.target));
})();
